$(".font-awesome-hover").mouseenter(function() {
    $(this)
        .find('i')
        .css("--fa-primary-color", "#1F305E")
        .css("--fa-secondary-color", "#2D68C4")
        .css("--fa-secondary-opacity", 0.85)
}).mouseleave(function() {
    $(this)
        .find('i')
        .css("--fa-primary-color", "")
        .css("--fa-secondary-color", "")
        .css("--fa-secondary-opacity", 0.5)
});
